/*eslint-disable */
import React, { Component } from "react";
import {
  Grid,
  Header,
  Icon,
  Button,
  Dropdown,
  input,
  Input,
  Loader,
} from "semantic-ui-react";
import ShipmentDetailsHeader from "./shipmentDetailsHeader";
import ReadAxios from "../axiosComponent/read";
import PdfAxios from "../axiosComponent/downloadpdf";
import FileCreatAxios from "../axiosComponent/fileupload";
import LoadingPlaceholder from "../placeholderComponent/loadingPlaceholder";
import ShipmentOrderTable from "./shipmentOrderTable";
import { translate } from "react-i18next";
import VendorRepliesTable from "./vendorRepliesTable";
import { Form as Formiker, Field, Formik } from "formik";
import { min, isEmpty, now } from "lodash";
import moment from "moment";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { createShipmentDispatcher } from "../../redux/actions/shipmentAction";
import { connect } from "react-redux";
import { MyNormalInput } from "../dynamicComponent/myInputs";
import { DateData } from "../dynamicComponent/datepick";
import UpdateAxios from "../axiosComponent/update";
import SearchDropdown from "../createShipmentComponent/searchDropdown";
import DeleteAxios from "../axiosComponent/delete";
import DeleteDocumentAxios from "../axiosComponent/deletedocument";
import Documentsupl from "./documents";
import ModalBroadCast from "./modalBroadCast";
import ModalReBroadcast from "./modalRebroadcast";
import ModalUndoBroadcast from "./modalUndoBroadcast";
import FormikModalAllot from "./modalAllot";
import { FEATURES } from "../../utils/constant";
import CreateAxios from "../axiosComponent/create";

class ShipmentDetials extends Component {
  constructor(props) {
    super(props);

    this.state = {
      shipmentDetail: null,
      selectedOrder: null,
      replies_fetch: null,
      order_fetch: null,
      bls: "",
      orders: [],
      blList: [],
      newDetails: null,
      bldocuments: [],
      iscanceled: false,
      shipmentEditMode: false,
      files: [],
      current_order: null,
      current_bl: null,
      show_current_bl: null,
      updateDoc: "",
      mystyle: {
        display: "table-cell",
        opacity: "1",
        verticalalign: "middle",
      },
    };
  }

  //   TODO: make both at same time
  async componentDidMount() {
    let steOrder = this.props.location.search.split("=")[2];
    console.log("oid", steOrder);
    this.fetchOrderDetails(steOrder);
    this.getBl(steOrder);
    let newshipmentid = this.props.location.search.split("=")[1];
    let shipmentId = newshipmentid ? newshipmentid.split("&")[0] : "";
    console.log("sid", shipmentId);
    this.setState({
      newDetails: shipmentId,
      selectedOrder: steOrder,
    });
    //TODO: null handling for api call
    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/shipments/${shipmentId}`,
    })
      .then((res) => {
        // this.props.create(temShipment);
        let orders = res.data.shipment.orders.map((item, index) => {
          return {
            key: index,
            value: item.vendor_order_id,
            text: "Order " + (index + 1),
            raw: { ...item },
          };
        });
        this.setState({
          shipmentDetail: res.data.shipment,
          orders: orders,
          iscanceled: res.data.shipment.is_cancelled,
          current_order: orders[0].key,
          forceUpdate: false,
        });
        // this.getBlList(this.state.orders[this.state.current_order].value);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getBl = (order) => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${order}/bl/list`,
    })
      .then((res) => {
        let bldata = res.data.data;
        this.setState({
          bls: bldata,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  fetchOrderDetails = (order) => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${order}`,
    })
      .then((res) => {
        let checkallotment = res.data.order;
        this.setState({
          order_fetch: checkallotment,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  setEditMode = (edit) => {
    console.log(edit);
  };

  setSourceDestination = async (name, value) => {
    if (value) {
      const { key, raw } = value;
      let checkPointsArray = await ReadAxios({
        url: `routeManager/${raw.routeMasterId}`,
      });
      checkPointsArray = isEmpty(checkPointsArray)
        ? []
        : checkPointsArray.data.resultSet;
      setFieldValue(name, key);
      // setFieldValue("source", checkPointsArray[0].checkPointName);
      // setFieldValue(
      //   "destination",
      //   checkPointsArray[checkPointsArray.length - 1].checkPointName
      // );
    } else {
      setFieldValue(name, value);
      // setFieldValue("source", "");
      // setFieldValue("destination", "");
    }
  };

  setCurrentOrderToShow = (name, data) => {
    this.setState({
      current_order: data.options.find((ele) => ele.value === data.value).key,
    });
    // this.getBlList(this.state.current_order);
  };

  reloadCurrentPage = () => {
    // this.props.history.go();
    window.location.reload();
  };

  undoBroadcast = async (order_id, shipment_id) => {
    try{
      await CreateAxios({
          completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${order_id}/undo/broadcast`,
          payload: { shipment_id },
        }) 
    }catch(err){
      console.log(`undo broadcast failed`,err);
    }
  };

  //   TODO: null handling
  render() {
    const {
      shipmentDetail,
      newDetails,
      iscanceled,
      bls,
      orders,
      order_fetch,
      replies_fetch,
      shipmentEditMode,
      blList,
      show_current_bl,
      current_bl,
      bldocuments,
      selectedOrder,
    } = this.state;
    const { t } = this.props;
    const documents = this.state.shipmentDetail;
    let doc = "";

    const customerNo = localStorage.getItem("customerNumber");

    return (
      <React.Fragment>
        <ShipmentDetailsHeader
          shipment={newDetails}
          order={order_fetch}
          cancel={this.props.permissions.TA_SHIPMENT.DELETE}
          iscancel={iscanceled}
          to={{
            pathname: "/edit-shipment",
            state: newDetails,
          }}
          title={+localStorage.getItem("customerNumber") == 503 ? "Booking Details" : t("title") || "Shipment Details"}
          LinkName="/shipment"
        />
        {shipmentDetail ? (
          <>
            <div className="pad w3-white small">
              <Formik
                initialValues={{
                  import_declaration_no: shipmentDetail.import_declaration_no,
                  shipment_reference_no: shipmentDetail.shipment_reference_no,
                  movement_type:
                    shipmentDetail.movement_type == "Import"
                      ? "import"
                      : "primary",
                  boarding_no: shipmentDetail.boarding_no,
                  no_of_vehicles: shipmentDetail.no_of_vehicles,
                  required_on: shipmentDetail.required_on_raw,
                  route_code: shipmentDetail.route_details.route_code,
                  route_name: shipmentDetail.route_details.route_name,
                }}
                onSubmit={(values, { setSubmitting }) => {
                  console.log(values);
                  let required_on = moment(values.required_on).format(
                    "YYYY-MM-DD HH:mm:ss"
                  );
                  UpdateAxios({
                    patchURL: `${process.env.REACT_APP_TA_API_URL}/shipments/${this.props.location.search.split("=")[1]
                      }`,
                    payload: { ...values, required_on },
                    uniqueId: this.state.newDetails,
                  })
                    .then((response) => {
                      this.props.success({
                        type: "success",
                        messageHeader: "Success",
                        messageBody: "Shipment Updated Successfully",
                      });
                      window.location.reload();
                    })
                    .catch((err) => {
                      console.log(err);
                      this.props.error({
                        type: "error",
                        messageHeader: "Error",
                        messageBody: err.response.data.error,
                      });
                    });
                  setSubmitting(false);
                }}
              >
                {({ touched, errors, values, setSubmitting, setFieldValue }) => (
                  <Formiker>
                    <Grid columns={4} className="ml-2">
                      <Grid.Row>
                        <Grid.Column width={3}>
                          <Header
                            className="p-bold-200 labelName"
                            size="tiny"
                            as="label"
                            color="grey"
                          >
                            {t("shipment.shipment_number") || "Shipment Number"}
                          </Header>
                        </Grid.Column>
                        <Grid.Column width={4}>
                          <Header
                            className="p-bold-500 labelName"
                            size="tiny"
                            as="label"
                            color="black"
                          >
                            {/* <Field disabled={shipmentEditMode ? false : true} className="p-disabled" component={MyNormalInput} name="shipment_reference_no" /> */}
                            {shipmentDetail.shipment_reference_no}
                          </Header>
                        </Grid.Column>
                        <Grid.Column width={3}>
                          <Header
                            className="p-bold-200 labelName"
                            size="tiny"
                            as="label"
                            color="grey"
                          >
                            {shipmentDetail.movement_type == "Import" ||
                              shipmentDetail.movement_type == "Importar"
                              ? t("shipment.estimated_on")
                              : t("shipment.requirement_date")}
                          </Header>
                        </Grid.Column>
                        <Grid.Column width={4}>
                          <Header
                            className="p-bold-500 labelName"
                            size="tiny"
                            as="label"
                            color="black"
                          >
                            {/* {shipmentDetail.required_on} */}
                            {shipmentEditMode == false ? (
                              <>{shipmentDetail.required_on}</>
                            ) : (
                              <DateData
                                // style={{ width: "100% !important" }}
                                name={"required_on"}
                                disabled={shipmentEditMode ? false : true}
                                autoComplete="off"
                                showTimeSelect
                                timeFormat="HH:mm"
                                popperClassName="dateTime"
                                dateFormat="dd/MM/yyyy HH:mm"
                                selected={
                                  new Date(shipmentDetail.required_on_raw)
                                }
                                timeIntervals={5}
                                customInput={
                                  <Input
                                    icon="time"
                                    // className="dateWidth"
                                    iconPosition="left"
                                  />
                                }
                              />
                            )}
                          </Header>
                        </Grid.Column>
                        <Grid.Column floated="right" width={4} className="display-flex-justify-right" >
                          {order_fetch && order_fetch.allotment_status ? (
                            <>
                              {(order_fetch &&
                                order_fetch.allotment_status &&
                                order_fetch.allotment_status.allotment_code ==
                                "ALLOC") ||
                                order_fetch.allotment_status.allotment_code ==
                                "CANCEL" ||
                                order_fetch.allotment_status.allotment_code ==
                                "COMPLETE" ? null : (
                                <>
                                  {this.props.permissions.TA_SHIPMENT.UPDATE ==
                                    true ? (
                                    <>
                                      <Button icon basic size="mini"
                                        className="ui green"
                                        type="button"
                                        onClick={() =>
                                          this.setState({
                                            shipmentEditMode: !shipmentEditMode,
                                          })
                                        }

                                      >
                                        <Icon
                                          name={
                                            shipmentEditMode ? "times" : "edit"
                                          }
                                        />
                                        {shipmentEditMode ? (
                                          <>
                                            {/* {t("action_button.cancel") ||"Cancel"} */}
                                          </>
                                        ) : (
                                          <>
                                            {/* {t("action_button.edit") || "Edit"} */}
                                          </>
                                        )}
                                      </Button>
                                    </>
                                  ) : null}
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              {this.props.permissions.TA_SHIPMENT.UPDATE ==
                                true ? (
                                <>
                                  <Button icon basic size="mini"
                                    className="ui green"
                                    type="button"
                                    onClick={() =>
                                      this.setState({
                                        shipmentEditMode: !shipmentEditMode,
                                      })
                                    }

                                  >
                                    <Icon
                                      name={shipmentEditMode ? "times" : "edit"}
                                    />
                                    {shipmentEditMode ? (
                                      <>
                                        {/* {t("action_button.cancel") || "Cancel"} */}
                                      </>
                                    ) : (
                                      <>
                                        {/* {t("action_button.edit") || "Edit"} */}

                                      </>
                                    )}
                                  </Button>
                                </>
                              ) : null}
                            </>
                          )}

                          {shipmentEditMode ? (
                            <Button icon basic size="mini"
                              className="ui blue"
                              type="submit"

                            >
                              <Icon name="save" />
                              {/* {t("action_button.save") || "Save"} */}
                            </Button>
                          ) : (
                            ""
                          )}
                          {/* </>
                      )} */}
                        </Grid.Column>
                      </Grid.Row>
                      {shipmentEditMode == true ? (
                        <>
                          <Grid.Row>
                            <Grid.Column width={3}>
                              <Header
                                className="p-bold-200 labelName"
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {t("shipment.route_code") || "Route"}
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={4}>
                              <Header
                                className="p-bold-500 labelName"
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                <SearchDropdown
                                  setField={(name, value) =>
                                    setFieldValue(name, value?.raw?.routeCode)
                                  }
                                  masterRoute="routeMaster"
                                  masterRouteKey="routeCode"
                                  masterRouteName="routeName"
                                  fieldName="route_code"
                                  className="ui input"
                                  deafultValue={
                                    shipmentDetail?.route_details?.route_name
                                  }
                                />
                                {/* {shipmentDetail.route_details.route_code} */}
                              </Header>
                            </Grid.Column>
                          </Grid.Row>
                        </>
                      ) : null}
                      <Grid.Row>
                        <Grid.Column width={3}>
                          <Header
                            className="p-bold-200 labelName"
                            size="tiny"
                            as="label"
                            color="grey"
                          >
                            {shipmentDetail.movement_type == "Import" ? (
                              <>
                                {t("shipment.pickuplocation") ||
                                  "From Location"}
                              </>
                            ) : (
                              <>
                                {t("shipment.from_location") || "From Location"}
                              </>
                            )}
                          </Header>
                        </Grid.Column>
                        <Grid.Column width={4}>
                          <Header
                            className="p-bold-500 labelName"
                            size="tiny"
                            as="label"
                            color="black"
                          >
                            {shipmentDetail.route_details.source}
                          </Header>
                        </Grid.Column>
                        <Grid.Column width={3}>
                          <Header
                            className="p-bold-200 labelName"
                            size="tiny"
                            as="label"
                            color="grey"
                          >
                            {shipmentDetail.movement_type == "Primary" ? (
                              <>
                                {t("shipment.to_location_d") || "To Location"}
                              </>
                            ) : (
                              <>{t("shipment.to_location") || "To Location"}</>
                            )}
                          </Header>
                        </Grid.Column>
                        <Grid.Column width={4}>
                          <Header
                            className="p-bold-500 labelName"
                            size="tiny"
                            as="label"
                            color="black"
                          >
                            {shipmentDetail.route_details.destination}
                          </Header>
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row>
                        <Grid.Column width={3}>
                          <Header
                            className="p-bold-200 labelName"
                            size="tiny"
                            as="label"
                            color="grey"
                          >
                            {t("shipment.required_vehicles") ||
                              "Required Vehicles"}
                          </Header>
                        </Grid.Column>
                        <Grid.Column width={4}>
                          <Header
                            className="p-bold-500 labelName"
                            size="tiny"
                            as="label"
                            color="black"
                          >
                            {shipmentDetail.no_of_vehicles}
                          </Header>
                        </Grid.Column>
                        <Grid.Column width={3}>
                          <Header
                            className="p-bold-200 labelName"
                            size="tiny"
                            as="label"
                            color="grey"
                          >
                            {t("shipment.movement_type") || "Movement Type"}
                          </Header>
                        </Grid.Column>
                        <Grid.Column width={4}>
                          <Header
                            className="p-bold-500 labelName movement_type"
                            size="tiny"
                            as="label"
                            color="black"
                          >
                            {shipmentDetail.movement_type}
                          </Header>
                        </Grid.Column>
                        {/* <Grid.Column width={3}>
                    <Header
                      className="p-bold-200 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      {t("shipment.base_rate") || "Base Rate"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-500 labelName"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                      {shipmentDetail.base_rate} /-
                    </Header>
                  </Grid.Column> */}
                      </Grid.Row>
                      <Grid.Row>
                      <Grid.Column width={3}>
                        {console.log(shipmentDetail,'rowdata003')}
                          <Header
                            className="p-bold-200 labelName"
                            size="tiny"
                            as="label"
                            color="grey"
                          >
                            {t("shipment.route_code_field") || "Route Code"}
                          </Header>
                        </Grid.Column>
                        <Grid.Column width={4}>
                          <Header
                            className="p-bold-500 labelName"
                            size="tiny"
                            as="label"
                            color="black"
                          >
                            {values.route_code}
                          </Header>
                        </Grid.Column>
                      </Grid.Row>

                      {/* <Grid.Column width={3}>
                    <Header
                      className="p-bold-200 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      {t("shipment.movement_type") || "Movement Type"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-500 labelName movement_type"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                      {shipmentDetail.movement_type}
                    </Header>
                  </Grid.Column> */}

                      {/* {(shipmentDetail.movement_type ===
                        "Import" || shipmentDetail.movement_type ===
                        "Importar") && localStorage.getItem('customerNumber') != 1122 ? (<>
                          <Grid.Row>
                            <Grid.Column width={3} >
                              <Header
                                className="p-bold-200 labelName"
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {t("shipment.import_decleration_number") || "Import Declaration Number"}
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={4}>
                              <Header
                                className="p-bold-500 labelName"
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                {/* {shipmentDetail.import_declaration_no ? shipmentDetail.import_declaration_no : "NA"} *
                                <Field disabled={shipmentEditMode ? false : true} className="p-disabled" component={MyNormalInput} name="import_declaration_no" />
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={3} >
                              <Header
                                className="p-bold-200 labelName"
                                size="tiny"
                                as="label"
                                color="grey"
                              >
                                {t("shipment.boarding_no") || "Import Declaration Number"}
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={4}>
                              <Header
                                className="p-bold-500 labelName"
                                size="tiny"
                                as="label"
                                color="black"
                              >
                                {/* {shipmentDetail.boarding_no ? shipmentDetail.boarding_no : "NA"} *
                                <Field disabled={shipmentEditMode ? false : true} className="p-disabled" component={MyNormalInput} name="boarding_no" />
                              </Header>
                            </Grid.Column>
                          </Grid.Row>
                        </>) :
                        (<>
                        </>)} */}

                      {/* {shipmentDetail.movement_type ===
                  "Import" || shipmentDetail.movement_type ===
                 "Importar" ? (<>
                    <Grid.Row>
                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-200 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {"Port Terminal"}
                        </Header>

                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-500 labelName"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {shipmentDetail.port_terminal}
                        </Header>
                      </Grid.Column>
                      <Grid.Column width={3}>
                        <Header
                          className="p-bold-200 labelName"
                          size="tiny"
                          as="label"
                          color="grey"
                        >
                          {"BL Number"}
                        </Header>

                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Header
                          className="p-bold-500 labelName"
                          size="tiny"
                          as="label"
                          color="black"
                        >
                          {shipmentDetail.bl_no}
                        </Header>
                      </Grid.Column>
                    </Grid.Row>
                  </>) :
                  (<>
                  </>)} */}
                      {/* <Grid.Row>
                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-200 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      {t("shipment.remarks") || "Remarks"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-500 labelName"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                      {shipmentDetail.remarks || " "}
                    </Header>
                  </Grid.Column>
                </Grid.Row> */}
                    </Grid>
                  </Formiker>
                )}
              </Formik>
            </div>
            <div className="pad w3-white small">
              <Grid columns={4} className="ml-2">
                <Grid.Row>
                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-200 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      {t("shipment.benchmark_rate") || "Benchmark Rate"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-200 labelName"
                      size="tiny"
                      as="label"
                      color="blue"
                    >
                      NA
                    </Header>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-200 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      {t("shipment.budgeted_distance") || "Budgeted Distance"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-200 labelName"
                      size="tiny"
                      as="label"
                      color="blue"
                    >
                      {/* 120 KM */}
                      {shipmentDetail.budgeted_kms || 0}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-200 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      {t("shipment.budgeted_time") || "Budgeted Time"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Header
                      className="p-bold-200 labelName"
                      size="tiny"
                      as="label"
                      color="blue"
                    >
                      {shipmentDetail.budgeted_time || 0}
                    </Header>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
            {(shipmentDetail.movement_type == "Import" ||
              shipmentDetail.movement_type == "Importar") &&
              this.props.permissions.TA_DOCUMENTS.VIEW == true ? (
              <>
                {bls != "" ? (
                  <>
                    <Documentsupl order={selectedOrder} />
                  </>
                ) : null}
              </>
            ) : null}
            <div className="pad w3-white">
              <Grid columns="2" className="ml-2">
                <Grid.Row verticalAlign="middle">
                  <Grid.Column width={12} floated="left">
                    <Header
                      className="p-bold-200 labelName"
                      size="tiny"
                      as="label"
                      color="blue"
                    >
                      {+localStorage.getItem("customerNumber") == 503 ? "Booking Details" : t("order_title") || "Order Details"}
                      {/* <Dropdown
                        defaultValue={
                          this.state.orders[this.state.current_order].value
                        }
                        options={this.state.orders}
                        name="current_order_index"
                        onChange={(name, data) => {
                          this.setCurrentOrderToShow(name, data);
                        }}
                      /> */}
                    </Header>
                  </Grid.Column>
                  { FEATURES.allotVendorOptionForBroadcastedOrders &&
                  <Grid.Column width={1} floated="right">
                    <Header
                      className="labelName"
                      size="tiny"
                      as="label"
                      color="blue"
                    >
                      {this.props.auth.role == "Quality Control" ||
                        this.props.auth.role == "Broker" ? null : (
                        <>
                          {order_fetch ? (
                            <>
                              {order_fetch.allotment_status &&
                                order_fetch.allotment_status.allotment_code == "BRDCST" &&
                                order_fetch.broadcast?.broadcast_end_datetime &&
                                moment(order_fetch.broadcast?.broadcast_end_datetime).utc().format("YYYY-MM-DD HH:mm:ss") < moment().format("YYYY-MM-DD HH:mm:ss")  &&
                                this.props.permissions.TA_SHIPMENT.UPDATE ==
                                true ? (
                                <>
                                <FormikModalAllot
                                order={order_fetch}
                                reFetchOrder={this.reloadCurrentPage}
                                role={this.props.auth.role}
                                permissions={this.props.permissions}
                                onSubmitFirst = {()=> this.undoBroadcast(order_fetch?.vendor_order_id , order_fetch?.shipment?.vendor_shipment_id)}
                                />
                                
                                </>
                              ) : null}
                            </>
                          ) : null}
                        </>
                      )}
                    </Header>
                  </Grid.Column>}
                  <Grid.Column width={2} floated="right">
                    <Header
                      className="p-bold-200 labelName"
                      size="tiny"
                      as="label"
                      color="blue"
                    >
                      {this.props.auth.role == "Quality Control" ||
                        this.props.auth.role == "Broker" ? null : (
                        <>
                          {order_fetch ? (
                            <>
                              {order_fetch.allotment_status &&
                                order_fetch.allotment_status.allotment_code ==
                                "BRDCST" &&
                                this.props.permissions.TA_SHIPMENT.UPDATE ==
                                true ? (
                                <ModalReBroadcast
                                  order={order_fetch}
                                  reFetchOrder={this.reloadCurrentPage}
                                  shipmentId={newDetails}
                                />
                              ) : null}
                            </>
                          ) : null}
                        </>
                      )}
                    </Header>
                  </Grid.Column>
                  {/* <Grid.Column width={2} floated="right">
                    <Header
                      className="p-bold-200 labelName"
                      size="tiny"
                      as="label"
                      color="blue"
                    >
                      {replies_fetch ? (
                        <>
                        {this.props.auth.role == "Quality Control" ? (
                          null
                        ) : (
                          <ModalUndoBroadcast orderID={selectedOrder.vendor_order_id} shipmentId={this.props.location.search.split("=")[1]}/>
                        )}
                        </>
                      ) : (
                          null
                        )}
                    </Header>
                  </Grid.Column> */}
                </Grid.Row>
                <Grid.Row>
                  {selectedOrder ? (
                    <ShipmentOrderTable
                      movement_type={shipmentDetail.movement_type}
                      budgeted_kms={shipmentDetail.budgeted_kms}
                      orderData={selectedOrder}
                      shipmentDetails={shipmentDetail}
                      role={this.props.auth.role}
                      currentOrder={this.state.current_order}
                      shipmentId={newDetails}
                      history={this.props.history}
                      order_fetch={this.state.order_fetch}
                    />
                  ) : null}
                </Grid.Row>
                {this.state.orders[this.state.current_order].raw
                  .allotment_status &&
                  this.state.orders[this.state.current_order].raw
                    .allotment_status.allotment_code == "BRDCST" && (
                    <>
                      <Grid.Row verticalAlign="middle">
                        <Grid.Column floated="left">
                          <Header
                            className="p-bold-200 labelName"
                            size="tiny"
                            as="label"
                            color="blue"
                          >
                            {t(
                              customerNo != 1158
                                ? "reply_vendor_title"
                                : "reply_title"
                            ) || "Reply From Vendors"}
                          </Header>
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row>
                        {this.state.orders[this.state.current_order].raw
                          .allotment_status &&
                          this.state.orders[this.state.current_order].raw
                            .allotment_status.allotment_code == "BRDCST" ? (
                          <VendorRepliesTable
                            orderData={
                              this.state.orders[this.state.current_order]
                            }
                            role={this.props.auth.role}
                            currentOrder={this.state.current_order}
                            shipmentId={newDetails}
                            history={this.props.history}
                          />
                        ) : null}
                      </Grid.Row>
                    </>
                  )}
              </Grid>
            </div>
            <div className="pad w3-small w3-white">
              <Grid columns={4} className="ml-2">
                <Grid.Row>
                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-200 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      {t("shipment.created_date_time") || "Created Date & Time"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-500 labelName"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                      {shipmentDetail.created_on}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={1}></Grid.Column>
                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-200 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      {t("shipment.created_by") || "Created By"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Header
                      className="p-bold-500 labelName"
                      size="tiny"
                      as="label"
                      color="black"
                    >
                      {shipmentDetail.created_by}
                    </Header>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>{" "}
          </>
        ) : (
          <LoadingPlaceholder />
        )}
      </React.Fragment>
    );
  }
}
const mapStateToProps = ({ permissions, auth }) => {
  return {
    permissions,
    auth,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    success: (alert) => dispatch(successAlertDispatcher(alert)),
    error: (alert) => dispatch(errorAlertDispatcher(alert)),
    create: (shipment) => dispatch(createShipmentDispatcher(shipment, true)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("shipment_details")(ShipmentDetials));
